import AppDataService from "../AppDataService";

export default class MessagingService {
  static async getUserList(data) {
    const queryParams = [
      data?.name ? `name=${data.name}` : "",
      `isForChat=${data?.isForChat ?? true}`,
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`user${queryString}`);
  }
  static async postConversationData(data) {
    return await AppDataService.post(`chat/conversations`, data);
  }

  static async postBroadcastMessage(data) {
    return await AppDataService.post(`chat/broadcast`, data);
  }

  static async getConversationList(data) {
    const queryParams = [
      data?.userId ? `userId=${data.userId}` : "",
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`chat/conversations${queryString}`);
  }

  static async patchConversationData(id, body) {
    return await AppDataService.patch(`chat/conversations/${id}`, body);
  }

  static async clearAllNotification(id) {
    return await AppDataService.patch(`notification/clear/all/${id}`, {});
  }
  static async patchVerifyOrderStatus(id, data) {
    return await AppDataService.patch(`order/${id}`, data);
  }
  static async deleteNotification(id) {
    return await AppDataService.patch(`notification/clear/${id}`, {});
  }
  static async postGroupData(data) {
    return await AppDataService.post(`group`, data);
  }
  static async getCreateGroupData(data) {
    return await AppDataService.get(`group?userId=${data?.userId}`);
  }
  static async patchGroupMemberWithGroupName(groupId, data) {
    return await AppDataService.patch(`group/${groupId}`, data);
  }
}
